<template>
    <base-modal hide-footer hide-header size="lg" @close="$emit('close')">
        <h3 class="editor-header"> {{ !cable || cable.id > 0 ? $t('cables.edit') : $t('cables.add') }}</h3>
        <div class="col-sm-12">
          <div v-if="updateCable" class="col-sm-12 editor-form" @click.stop="null">
            <h4 class="form-header">
              {{ $t('street_lights.basic_info') }}
            </h4>
            <div class="row px-2">
              <div class="col-sm-4 p-1">
                <span class="span-title">{{ $t('street_lights.status') }}</span>
                  <select
                      id="cableStatus"
                      v-model="updateCable.status"
                      class="form-select form-select-sm"
                  >
                      <option :value="null">
                          {{ $t('street_lights.select_status') }}
                      </option>
                      <option v-for="option in statusOptions" :key="option.value" :value="option.value">
                          {{ option.text }}
                      </option>
                  </select>
              </div>
              <div class="col-sm-4 p-1">
                <span class="span-title">{{ $t('cables.purpose') }}</span>
                  <select
                      id="cableClass"
                      v-model="updateCable.purpose"
                      class="form-select form-select-sm"
                  >
                      <option v-for="option in purposeOptions" :key="option.value" :value="option.value">
                          {{ option.text }}
                      </option>
                  </select>
              </div>
              <div class="col-sm-4 p-1">
                <span class="span-title">{{ $t('cables.type') }}</span>
                  <select
                      id="cableType"
                      v-model="updateCable.type"
                      class="form-select form-select-sm"
                  >
                      <option v-for="option in cableTypeOptions" :key="option.value" :value="option.value">
                          {{ option.text }}
                      </option>
                  </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="margin-top: -.35em">
                <span class="span-title">{{ $t('street_lights.station') }}</span>
                  <select
                      id="cableStation"
                      v-model="selectedStation"
                      class="form-select form-select-sm"
                  >
                      <option :value="null">
                          {{ $t('street_lights.select_station') }}
                      </option>
                      <option v-for="station in stations" :key="station.value" :value="station.value">
                          {{ station.text }}
                      </option>
                  </select>
              </div>
              <div class="col-sm-6">
                <open-contract-filter
                  :from="now"
                  :contract="preselectedContract"
                  :show-company="false"
                  :show-title="true"
                  style="margin-left: -2px; margin-right: -3px;"
                  @loading="loading=true"
                  @loading-completed="loading=false"
                  @contract-selected="setContract"
                />
              </div>
            </div>
            <hr>
            <div class="col-sm-12 button-container pt-4 pb-0 mb-0">
              <button
                class="btn btn-secondary form-button"
                @click.stop="$emit('close')"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                class="btn btn-success form-button"
                :disabled="loading||cable===null"
                @click.stop="submit"
              >
                {{ $t('common.save') }}
              </button>
            </div>
          </div>
          <div
            v-if="loading"
            id="loader"
            class="spinner"
          />
        </div>
  </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import BaseModal from '../BaseModal'
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {timeUtils} from "@/components/mixins/TimeUtils";
import {cableHelper} from "@/components/mixins/CableMixin";
import {streetLightHelper} from "@/components/mixins/StreetLightMixin";
import {inject} from "vue";

export default {
    name: 'CableEditor',
    components: {OpenContractFilter, BaseModal},
    mixins: [restApi, timeUtils, cableHelper, streetLightHelper],
    props: {
        selectedContract: {
            type: Object,
            default: null
        },
        cable: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            updateCable: null,
            contract: null,
            selectedStation: null,
            stations: [],
        }
    },
    emits: ['close', 'closeAndUpdate'],
    computed: {
        preselectedContract() {
            return this.updateCable && this.updateCable.contract ? this.updateCable.contract : null
        },
        now() {
            return new Date().toISOString();
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.fetchStations()
        if (!this.cable) {
            this.updateCable = {
                id: null,
                station: null,
                status: null,
                contract: null,
                type: null,
                purpose: null,
            }
        } else {
            this.contract = this.cable.contract ? this.cable.contract : null
            this.selectedStation = this.cable.station?.id
            this.updateCable = this.cable
        }
    },
    methods: {
        fetchStations() {
            this.loading = true
            this.stations = []
            this.restFetch(this.powerStationUrl, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            if (response && response.data) {
                response.data.forEach(station => {
                    this.stations.push({value: station.id, text: station.id + ' ' + station.location_name})
                })
            }
            this.loading = false
        },
        submit: function () {
            this.loading = true
            if (this.contract) {
                this.updateCable.contract = this.contract
            }
            if (!this.selectedStation) {
                this.showAlert(this.$t('street_light.error_station'))
                return;
            } else {
                this.updateCable.station = {id: this.selectedStation}
            }
            // TODO - Check geometry!!!
            if (this.updateCable.id && this.updateCable.id > 0) {
                this.restUpdate(this.cableUrl, this.updateCable, this.success, this.fail)
            } else {
                this.restAdd(this.cableUrl, this.updateCable, this.success, this.fail)
            }
        },
        success: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_failed'))
        },
        setContract: function (contract) {
            this.contract = contract
        }
    }
}
</script>
<style>
@import "../../styles/modal.css";
</style>
